(function () {
  function initStickyOffset() {
    var header = document.querySelector('.header-area.sticky-bar');
    if (!header) return;

    function setHeaderHeightVar() {
      var h = header.offsetHeight || 0;
      document.documentElement.style.setProperty('--stickyHeaderH', h + 'px');
    }

    // Initial + on resize (fonts can affect height)
    setHeaderHeightVar();
    window.addEventListener('resize', setHeaderHeightVar);

    // NOTE: this used to also toggle a `body.has-sticky-header` class on
    // scroll (+ a MutationObserver on the header's class attribute) so a
    // CSS rule could add `padding-top` once the header became sticky. The
    // header is now always position:fixed from page load (layout/theme.liquid
    // reserves its space unconditionally via #header-spacer), so that extra
    // padding only stacked a second, redundant offset on top of the
    // spacer's the instant you scrolled past the .stick threshold -- felt
    // as a double-scroll jerk. Removed 2026-07-02; --stickyHeaderH is kept
    // in case anything else reads it, but nothing toggles body padding here anymore.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyOffset);
  } else {
    initStickyOffset();
  }
})();